// extracted by mini-css-extract-plugin
export default {"template":"GDQGnlE2OmsFqXW6N8u2","title":"EBLIyYwyHO5ngKIOcs7Y","content":"uWb1Hj4tdEtbl3M4_E5U"};